var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgFooter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 856,
    viewBox: "0 0 1440 856",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_23",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -146,
    y: -273,
    width: 1682,
    height: 1946
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1536 -196.031L1473 1319.07L1512 1482.57L-30.5 1673C-103.83 1142.26 -257.2 321.031 -11 511.823C263.5 724.55 611.5 663.24 780 162.541C1001.51 -495.667 1347.33 -218.636 1536 -196.031Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_23)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_52_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-205.41 953L1551 953L1551 -296L-205.41 -296L-205.41 953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.635 963.368L1562.59 963.368L1611.38 683.44L173.32 268.733C28.78 362.652 -222.85 542.562 -73.0699 510.849C76.72 479.136 702.477 799.314 996.635 963.368Z",
    fill: "#4C3238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.71 355.305V906.65C1291.05 588.794 255.97 506.396 -225.11 504.929L-403 -438.71L541.14 -200.44L1582.71 355.305Z",
    fill: "#554DDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.54 -735.14L1601.22 407.744C1557.85 553.832 784.428 710.692 173.14 216.582C-438.14 -277.53 -866.91 -312.3 -1307.18 -310.61L1423.54 -735.14Z",
    fill: "#4E9AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633 -418.55V189.257C1591.53 261.615 1090.83 280.63 755.407 -25.2941C419.98 -331.22 154.28 -383.89 -122.19 -418.55L1633 -418.55Z",
    fill: "#44164F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41 913.885L906.618 1046.47L1019.63 785.758L-281.26 45.7068C-443.78 103.153 -730.55 219.109 -577.51 223.367C-424.47 227.625 108.87 685.486 356.41 913.885Z",
    fill: "#4EF4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205.41 491.943V954.83C327.82 1117.05 1316.45 1344.17 1005.17 954.83C693.899 565.493 68.4198 484.015 -205.41 491.943Z",
    fill: "#0B31B6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_52_23",
    x: -1537.18,
    y: -965.14,
    width: 3400.18,
    height: 2364.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 115,
    result: "effect1_foregroundBlur_52_23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 856,
    fill: "white",
    transform: "translate(1440 856) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFooter1);
export default __webpack_public_path__ + "static/media/bg_footer1.79a3d0bc569f2f6d85c505edb7545ad7.svg";
export { ForwardRef as ReactComponent };